import { render, staticRenderFns } from "./AssignRulesList.vue?vue&type=template&id=2e28d59a&scoped=true&"
import script from "./AssignRulesList.vue?vue&type=script&lang=ts&"
export * from "./AssignRulesList.vue?vue&type=script&lang=ts&"
import style0 from "./AssignRulesList.vue?vue&type=style&index=0&id=2e28d59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28d59a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
